const DEFAULT_THRESHOLD = {
  OCCUPANCY: 60,
  CHARGED_VOLUME: 250,
  SESSION: 25,
}

module.exports = {
  DEFAULT_THRESHOLD,
}
